// extracted by mini-css-extract-plugin
export default {"timePartContainer":"TimePart_timePartContainer__l3KKS","label":"TimePart_label__QGmIp","heading":"TimePart_heading__QTZuX"};